import type { AxiosResponse } from 'axios';

export const downloadFile = (
  response: AxiosResponse<unknown>,
  defaultFilename: string,
  mimeType = 'application/octet-stream',
): void => {
  const contentDisposition = response.headers['content-disposition'] as
    | string
    | undefined;
  let filename = defaultFilename;

  if (contentDisposition) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i;
    const filenameMatch = filenameRegex.exec(contentDisposition);
    if (filenameMatch?.[1]) {
      filename = filenameMatch[1].replace(/['"]/g, '');
    }
  }

  const content =
    mimeType === 'application/json'
      ? JSON.stringify(response.data, null, 2)
      : response.data;
  const blob = new Blob([content as BlobPart], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const generateTimestampedFilename = (
  prefix: string,
  extension: string,
): string => {
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
  return `${prefix}_${timestamp}.${extension}`;
};
